export default __webpack_public_path__ + "static/media/img9.baa8b030.png";